import React, { useState, useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../../../redux/hooks';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import useMediaQuery from '@mui/material/useMediaQuery';

// Components 

import Box from '@mui/material/Box';

interface Props { 
    icon: React.ReactNode; 
    title: string; 
    description: string; 
}

const InfoBox: React.FC<Props> = ( {icon, title, description }) => {

    const dispatch = useAppDispatch(); 
    const { t } = useTranslation(); 
    const navigate = useNavigate(); 
    const isMobile = useMediaQuery('(max-width: 768px)'); // Sync breakpoint with parent

    const colors = useAppSelector(state => state.theme.colors); 

    return (

        <Box
            sx={{ 
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center', 
                textAlign: 'center', 
                width: isMobile ? '90%' : 'auto', // Take more width on mobile, auto adjusts in flex row
                maxWidth: 280, // Set a max-width for desktop/row layout
                flex: isMobile ? 'none' : 1, // Allow equal flexing in row layout
            }}
        >

            {/* Icon Container */}
            <Box
                sx={{ 
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center', 
                    justifyContent: 'center', // Center icon vertically and horizontally
                    width: 50,
                    height: 50,
                    borderRadius: '50%', 
                    backgroundColor: 'rgba(177, 168, 168, 0.2)', // Lighter background
                }}
            >
                {icon}
            </Box>

            {/* Title */}
            <Box sx={{ 
                marginTop: 1.5, // Slightly reduced margin
                fontWeight: 'bold', 
                fontSize: isMobile ? 14 : 15, // Adjust font size
            }}>{t(title)}</Box>

            {/* Description */}
            <Box sx={{ 
                marginTop: 1, // Reduced margin
                fontSize: 12,
                width: '90%', // Use relative width
                color: 'rgba(170, 170, 170)',
                lineHeight: 1.4, // Improve readability
            }}>{t(description)}</Box>
            
        </Box>

  );

};

export default InfoBox;